import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { Subscription } from 'rxjs';
import { OdometerReading } from 'src/app/entities/OdometerReading';
import { Project } from 'src/app/entities/Project';
import { ActivityLogService } from 'src/app/services/activityLog.service';
import { OdometerReadingService } from 'src/app/services/odometer-reading.service';
import { ProjectService } from 'src/app/services/project.service';
import { TimeService } from 'src/app/services/time.service';
import { MileageLogCardData } from '../mileage-log-card/mileage-log-card.component';
import { OdometerReadingModalComponent } from '../odometer-reading-modal/odometer-reading-modal.component';

@Component({
  selector: 'app-mileage-log',
  templateUrl: './mileage-log.component.html',
  styleUrls: ['./mileage-log.component.scss'],
})
export class MileageLogComponent implements OnInit, OnDestroy {
  @Input() userId: number;
  @Input() date: dayjs.Dayjs;
  @Input() highlightOpenOdometerReadings: boolean = false;
  @Input() canEdit: boolean = false;
  @Input() allowClosure: boolean = false;
  odometerReadings: OdometerReading[];
  projects: Project[];
  totalMileage: number;
  cards: MileageLogCardData[] = [];
  odometerReadingChangeDetectionSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private timeService: TimeService,
    private odometerReadingService: OdometerReadingService,
    private projectService: ProjectService,
    private activityLogService: ActivityLogService,
  ) {
    this.odometerReadingChangeDetectionSubscription = this.odometerReadingService.changeEmitted$.subscribe(async change => {
      this.loadOdometerReadings();
    });
  }

  async ngOnInit() {
    await this.loadProjects();
    await this.loadOdometerReadings();
  }

  ngOnDestroy() {
    this.odometerReadingChangeDetectionSubscription.unsubscribe();
  }

  async loadOdometerReadings() {
    this.odometerReadings = (await this.odometerReadingService.getOdometerReadingsByUserIdDate(this.userId, this.date)).sort((a, b) => a.OdometerStart - b.OdometerStart);
    this.odometerReadings = this.odometerReadingService.sortOdometerReadingsByEndOdometer(this.odometerReadings);
    this.totalMileage = this.odometerReadingService.getSumTotalMileageForOdometerReadings(this.odometerReadings);

    let cards: MileageLogCardData[] = [];

    for (let reading of this.odometerReadings) {
      const activityLog = await this.timeService.getActivityLogForOdometerReading(reading);
      const project = await this.projectService.getProjectByOnlineId(activityLog.ProjectId);

      cards.push({
        odometerReading: reading,
        activityLog,
        project,
        date: this.date,
        highlighted: this.highlightOpenOdometerReadings && !reading.IsClosed,
        allowClosure: this.allowClosure,
      });
    }

    this.cards = cards;
  }

  async loadProjects() {
    const activityLogs = await this.activityLogService.getActivityLogsByUserIdDate(this.userId, this.date);
    const projectsPromises = activityLogs.map(activityLog => this.projectService.getProjectByOnlineId(activityLog.ProjectId));

    const projects = await Promise.all(projectsPromises);
    this.projects = projects.filter(project => project.RequireMileage).filter((project, index, self) => self.findIndex(p => p.Id === project.Id) === index);
  }

  async onAdd() {
    const modal = await this.modalController.create({
      component: OdometerReadingModalComponent,
      cssClass: "base-modal",
      componentProps: {
        date: this.date,
        projects: this.projects,
      },
    });

    await modal.present();
  }
}
